export interface ScoreParams {
  initialObjectiveValue: number
  initialIPOptimalValue: number
  initialVolume: number
  currentObjectiveValue: number
  currentVolume: number
}

export function computeScore(params: ScoreParams): number {
  const {
    initialObjectiveValue,
    initialIPOptimalValue,
    initialVolume,
    currentObjectiveValue,
    currentVolume,
  } = params

  const volumeReductionPct = initialVolume > 0 ? ((initialVolume - currentVolume) / initialVolume) * 100 : 0

  if (initialObjectiveValue > 0 && initialIPOptimalValue >= 0) {
    const denom = initialObjectiveValue - initialIPOptimalValue
    const lpReductionFactor = denom !== 0 ? (initialObjectiveValue - currentObjectiveValue) / denom : 0
    const volumeReductionFactor = volumeReductionPct / 100
    return Math.round(100 * lpReductionFactor + 500 * volumeReductionFactor)
  }

  // Fallback: simple volume-based scoring (keep legacy behavior)
  return Math.round(volumeReductionPct * 10)
}

